import { ADMIN_ROUTE_PREFIX, APP_ROUTE_PREFIX, SUPER_ADMIN_ROUTE_PREFIX, TRAINER_ROUTE_PREFIX } from "routes/RoutePrefix";
import RouteConstant from "routes/constant/RouteConstant";
import useAuthRepo from 'services/repo/useAuthRepo'
import Constant from 'utils/Constants'

export default function useUserLoginRedirectionHook() {
    const { chooseProfile } = useAuthRepo()

    const userLoginDefaultRedirection = (roleKeySetting, redirectUrl = null) => {

        if (redirectUrl) return redirectUrl
    
        if (roleKeySetting.toLowerCase() === Constant.roleSetting.TRAINEE.toLowerCase()) return APP_ROUTE_PREFIX
        if (roleKeySetting.toLowerCase() === Constant.roleSetting.TRAINER.toLowerCase()) return TRAINER_ROUTE_PREFIX
        if (roleKeySetting.toLowerCase() === Constant.roleSetting.ADMINBC.toLowerCase()) return ADMIN_ROUTE_PREFIX
        if (roleKeySetting.toLowerCase() === Constant.roleSetting.ADMIN.toLowerCase()) return ADMIN_ROUTE_PREFIX
        if (roleKeySetting.toLowerCase() === Constant.roleSetting.SUPERADMIN.toLowerCase()) return SUPER_ADMIN_ROUTE_PREFIX

        return APP_ROUTE_PREFIX

    }

    const forceUserLoginRedirection = async (roleId, profileId, bankChannelId=-1, redirectUrl=null, deviceId='') => {
        
        return new Promise(async (resolve, reject)=>{
            
            let defaultBankChannelId = bankChannelId !== null || typeof bankChannelId !== 'undefined' ? bankChannelId : -1;
            let res = await chooseProfile(roleId, profileId, defaultBankChannelId, deviceId)
            if(res?.isSuccess) {
                resolve(userLoginDefaultRedirection(res?.data?.lstLunaSettingDto?.keySetting, redirectUrl))
            } else {
                reject(res)
            }
        })
    }

    const userLoginRedirection = async (roles=[], profiles=[], bankChannel=null, redirectUrl=null) => {
        
        return new Promise(async (resolve, reject)=>{
            if(roles?.length === 1 && profiles?.length === 1 && (bankChannel == null || bankChannel?.length === 1 || bankChannel?.length === 0) ) {

                let defaultBankChannelId = bankChannel !== null || typeof bankChannel !== 'undefined' || bankChannel?.length > 0 ? bankChannel[0]?.bankChannelId : -1;
                let res = await chooseProfile(roles[0].roleId, profiles[0].profileTypeId, defaultBankChannelId)
                if(res?.isSuccess) {
                    resolve(userLoginDefaultRedirection(res?.data?.lstLunaSettingDto?.keySetting, redirectUrl))
                } else {
                    reject(res)
                }
            }
            
            resolve(`/${RouteConstant.chooseProfile}${!redirectUrl ? '' : `?redirectUrl=${redirectUrl}`}`)

        })
    }

    return {
        userLoginDefaultRedirection,
        forceUserLoginRedirection,
        userLoginRedirection
    }
}
